// authScreens.js - which routes the authed navigator registers (WP7, AIT-291).
// A restricted (expired-subscription) user may only reach the upgrade/payment
// screens (and the internal admin panel); everything else is not registered.

export const RESTRICTED_SCREEN_NAMES = ["UpgradePlan", "PaymentSuccess", "PaymentCancel", "InternalAdmin"];
const UPGRADE_ROUTE = "UpgradePlan";
const PUBLIC_ROUTES = ["AIExhibit"]; // lives outside the authed stack

export const isRestrictedUser = (isAuthed, user) =>
  !!isAuthed && user?.subscription_restricted === true;

export const isScreenAvailable = (name, restricted) =>
  !restricted || RESTRICTED_SCREEN_NAMES.includes(name);

export const getInitialAuthRoute = ({ restricted, defaultRoute }) => {
  if (!restricted) return defaultRoute;
  if (RESTRICTED_SCREEN_NAMES.includes(defaultRoute) || PUBLIC_ROUTES.includes(defaultRoute)) {
    return defaultRoute;
  }
  return UPGRADE_ROUTE;
};

export const getNavigatorKey = (authToken, restricted) => {
  if (!authToken) return "guest";
  return restricted ? "auth-restricted" : "auth";
};
